export const PENDING_PAYMENT_METHOD_STORAGE_KEY = 'pendingPaymentMethodUpdateId';

export const PAYMENT_METHOD_STATUS_SORT_ORDER: Record<string, number> = {
  PROCESSING: 0,
  REQUIRES_ACTION: 1,
  ACTIVE: 2
};
